import { Form, FormItemProps, Select } from 'antd';
import React, { ReactElement } from 'react';
import { LeashContent } from 'leash/utilities/localStorage/leashContentStorage';
import { Airline } from 'types';
const { Option } = Select;

export function FieldState(props: FormItemProps): ReactElement | null {
  if (!LeashContent?.airlines) return null;
  const { name, label, required = true } = props;

  return (
    <Form.Item
      name={name}
      label={label}
      rules={[{ required, message: 'Please select one option' }]}
    >
      <Select
        data-testid="field-state"
        showSearch
        placeholder="Select a state"
        optionFilterProp="children"
        filterOption={(input, option) => {
          return option?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0;
        }}
      >
        {LeashContent.states.map((s: Airline) => (
          <Option value={s.id} key={s.id}>
            {s.name}
          </Option>
        ))}
        <Option value="foo">Example</Option>
      </Select>
    </Form.Item>
  );
}
